import React, { useEffect } from 'react';
import AppLoginDialog from '../../common/AppLoginDialog';
import { useQuery } from '@tanstack/react-query';
import { handleGetUserService } from '../../../services/users';
import { ApiResponse } from '../../../services/axiosInstance';
import { SingleUserResponse } from '../../../pages/users/components/UserScreens/users';
import QUERY_KEYS from '../../../constants/queryKeys';
import AppChangePasswordDialog from '../../common/AppChangePasswordDialog';

const ChangePasswordPopup = () => {
  const [openModal, setOpenModal] = React.useState(false);
  const [openChangePasswordDialog, setOpenChangePasswordDialog] = React.useState(false);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user") as string)
    : null;
  const { data: userData } = useQuery<
    ApiResponse<SingleUserResponse>,
    Error,
    SingleUserResponse
  >({
    queryKey: [QUERY_KEYS.GET_SINGLE_USER],
    queryFn: () => handleGetUserService(user._id),
    enabled: !!user,
    staleTime: 0,
  });
  useEffect(() => {
    if (userData?.data?.shouldChangePassword) {
      setOpenModal(true);
      setOpenChangePasswordDialog(false);
    }
  }, [userData]);
  return (
    <>
      <AppLoginDialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={() => {
          setOpenModal(false);
          setOpenChangePasswordDialog(true);
        }}
      />
      <AppChangePasswordDialog
        open={openChangePasswordDialog}
        onClose={() => setOpenChangePasswordDialog(false)}
      />
    </>
  );
}

export default ChangePasswordPopup